/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import type * as Types from '@root/gql/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { UseQueryResult } from '@tanstack/react-query';
import { QueryClient } from '@tanstack/react-query';
import { gqlRequest } from '@root/gql/utils/gqlRequest';
import { getEventsQuery } from '../graphs/getEvents.query';

export type GetEventsQueryVariables = Types.Exact<{
  dto: Types.GetEventsDto;
}>;

export type GetEventsQuery = {
  __typename?: 'Query';
  events?: {
    __typename?: 'EventAggregatePaginatedResponseDto';
    data: Array<{
      __typename?: 'EventAggregate';
      categoryIds?: Array<number> | null;
      dateTime?: string | null;
      createdAt: Date;
      deletedAt?: Date | null;
      additionalContent?: string | null;
      id: number;
      isPublished: boolean;
      language: string;
      mainImageUrl?: string | null;
      name: string;
      onlyByUri?: boolean | null;
      price: number;
      purchaseLimit?: number | null;
      briefDescription?: string | null;
      termsAndConditions?: string | null;
      type: string;
      updatedAt?: Date | null;
      images?: Array<{
        __typename?: 'ProductImageFieldValue';
        imageUrl: string;
        priority: number;
      }> | null;
      offerPrice?: {
        __typename?: 'GetProductOfferPriceResponseDto';
        discountedPrice: number;
        discountName?: string | null;
        fullPrice: number;
      } | null;
      options?: Array<{
        __typename?: 'ProductOptionEntity';
        createdAt?: Date | null;
        deletedAt?: Date | null;
        id: number;
        language: string;
        name: string;
        price: number;
        updatedAt?: Date | null;
        offerPrice?: {
          __typename?: 'GetProductOfferPriceResponseDto';
          discountedPrice: number;
          discountName?: string | null;
          fullPrice: number;
        } | null;
      }> | null;
      settings?: {
        __typename?: 'ProductSettingsEntity';
        createdAt?: Date | null;
        deletedAt?: Date | null;
        id: number;
        productId: number;
        productLevelQuantity?: number | null;
        quantityLevelSetting: string;
        redemptionValidityPeriodMonths: number;
        salesGeneratedByThirdParties: boolean;
        updatedAt?: Date | null;
      } | null;
    }>;
    meta: {
      __typename?: 'PaginatedResponseMetaDto';
      currentPage: number;
      finalPage: number;
      limitPerPage: number;
      total: number;
    };
  } | null;
};

export const getEventsQueryImperative = (
  variables: GetEventsQueryVariables,
  headers?: RequestInit['headers']
) => gqlRequest<GetEventsQuery, GetEventsQueryVariables>(getEventsQuery, variables, headers);

export const getEventsQueryKey = (variables?: GetEventsQueryVariables) =>
  ['GetEvents', variables].filter((x) => x);

export const getEventsQueryPrefetch = async (
  queryClient: QueryClient,
  variables: GetEventsQueryVariables,
  options?: {
    headers?: RequestInit['headers'];
  }
) => {
  await queryClient.prefetchQuery(getEventsQueryKey(variables), () =>
    getEventsQueryImperative(variables, options?.headers)
  );
};

export const useGetEventsQuery = <TError = unknown>(
  variables: GetEventsQueryVariables,
  options?: UseQueryOptions<GetEventsQuery, TError, GetEventsQuery>,
  headers?: RequestInit['headers']
): UseQueryResult<GetEventsQuery> =>
  useQuery<GetEventsQuery, TError, GetEventsQuery>(
    ['GetEvents', variables],
    () => getEventsQueryImperative(variables as GetEventsQueryVariables, headers),
    options
  );
